import { AxiosRequestConfig } from 'axios';
import { GetIndicatorsData } from './indicators.types';

class IndicatorsRequestConfig {
  getIndicators = (data: GetIndicatorsData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'indicators/getIndicators',
    data
  });
}

export const indicatorsRequestConfig = new IndicatorsRequestConfig();
